import React from 'react';
import {QuestionCSCQ} from '@learningblocks/protocol-components';
import {VISIBILITY} from '@learningblocks/exp-constants/lib/Utilities';
import './style.scss';

export function QuestionColor(props) {
  if (props.visibility === VISIBILITY.VISIBLE) {
    return <QuestionCSCQ {...props} className='old_question_color' />;
  } else {
    return (
      <div className='question__hidden'>
        <h3 className='qustion__hidden-message'>Solve Previous Question.</h3>
      </div>
    );
  }
}
